import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';

import { componentSeasonOperations } from '../../redux/ducks/componentSeason';

const withComponentSeasons = WrappedComponent => {
    const Wrapper = (props) => {
        const componentSeasons = useSelector(({ componentSeason }) => componentSeason.componentSeasonsState.componentSeasons);
        const dispatch = useDispatch();

        useEffect(() => {
            if (componentSeasons.length === 0) {
                dispatch(componentSeasonOperations.fetchComponentSeasons());
            }
        }, []);

        if(Object.keys(componentSeasons).length > 0) {
            return <WrappedComponent {...props} />;
        }
        return null;
    };
    Wrapper.displayName = `WithComponentSeasons${WrappedComponent.displayName}`;

    return Wrapper;
};

export default withComponentSeasons;